import { ModelBase } from "../shared/model.base";
import { ColumnTitle } from "../../decorators/shared/column-title.decorator";
import { ColumnType } from "../../decorators/shared/column-type.decorator";
import { TableColumns } from "../../decorators/shared/table-columns.decorator";
import { DataType } from "../../enums/shared/enums";
import { IdName } from "../shared/id-name.type";
import { Grupo } from "../groups/grupo.type";
import { ShortCode } from "../shared/shortcode.type";

export class Sms extends ModelBase {
    validityPeriod: number;
    validity_period: number;
    execute_end_date: Date;
    execute_time: Date;
    message: string;
    recurrence_mode: string;
    msisdn: Array<string>;

    url_code: string;

    status: IdName;
    groups: Array<Grupo>;
    shortCode: ShortCode;

    @ColumnTitle("Nombre")
    name: string;

    @ColumnTitle("Tipo")
    type: string;

    @ColumnTitle("Fecha de Creacion")
    @ColumnType(DataType.date)
    create_date: Date;

    @ColumnTitle("Fecha de Ejecucion")
    @ColumnType(DataType.date)
    execute_date: Date;

    constructor() {
        super();

        this.name = "";
        this.type = "";
        this.create_date = null;
        this.execute_date = null;
        this.msisdn = new Array<string>();
        this.groups = new Array<Grupo>();
    }
}
